import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';

/**
 * A ticker that opens its settlement window as a TradingView script.
 *
 * `build` is called only when the dialog opens, so a table of thirty tickers
 * does not generate thirty scripts nobody asked for. When it returns null --
 * a window that cannot be placed -- the ticker stays plain text.
 */
export default function SymbolChart({ symbol, build, advice }) {
  const [script, setScript] = useState(null);
  const [copied, setCopied] = useState(false);
  const [copyError, setCopyError] = useState('');
  if (!build) return <>{symbol}</>;
  const open = () => {
    const s = build();
    if (!s) return;
    setCopied(false);
    setCopyError('');
    setScript(s);
  };
  const close = () => setScript(null);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(script);
      setCopied(true);
      setCopyError('');
    } catch {
      setCopyError('Select the script below and copy it manually.');
    }
  };
  return <>
    <Button color="link" className="p-0 align-baseline fw-semibold" title={`Check ${symbol} on TradingView`} onClick={open}>{symbol}</Button>
    <Modal isOpen={!!script} toggle={close} size="lg" scrollable>
      <ModalHeader toggle={close}>Check {symbol} on TradingView</ModalHeader>
      <ModalBody>
        <p className="text-muted fs-13">Open the {symbol} chart on TradingView, paste this into the Pine editor and press <em>Add to chart</em>. The shaded band is the settlement window; the table reads the start, high, low and end prices off the chart beside the prices this forecast was settled at.{advice && <> {advice}</>}</p>
        <div className="d-flex gap-2 mb-2">
          <Button color={copied ? 'success' : 'primary'} size="sm" onClick={copy}><i className="ri-file-copy-line align-bottom me-1" />{copied ? 'Copied!' : 'Copy'}</Button>
        </div>
        {copyError && <p className="text-warning fs-13">{copyError}</p>}
        <pre className="bg-light p-3 fs-12 mb-0" style={{ maxHeight: '50vh', overflow: 'auto', whiteSpace: 'pre' }}>{script}</pre>
      </ModalBody>
    </Modal>
  </>;
}
